import { render, staticRenderFns } from "./list-upload.vue?vue&type=template&id=0b87ab2c&"
import script from "./list-upload.vue?vue&type=script&lang=js&"
export * from "./list-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports